import { Component, ViewChild, inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from '@next/core-lib/dialog';
import { SelectedCustomer, UserSelectors } from '@next/core-lib/user';
import { Actions } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  RequestsColumnTypes,
  RequestsOverviewModel,
} from 'src/app/dashboard/components/overview/models/overview.model';

import { ClosedRequestsOverviewDataSource } from 'src/app/my-advertisements/datasources/closed-requests-datasource/closed-requests.datasource';

@Component({
  selector: 'app-closed-requests-overview-table',
  templateUrl: './closed-requests-overview-table.component.html',
  styleUrls: ['./closed-requests-overview-table.component.scss'],
  providers: [DialogService],
  standalone: false,
})
export class ClosedRequestsOverviewTableComponent {
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);

  readonly dataSource = new ClosedRequestsOverviewDataSource(this.store, this.actions$);
  readonly displayColumns = [
    RequestsColumnTypes.manureCategory,
    RequestsColumnTypes.manureType,
    RequestsColumnTypes.amountInTons,
    RequestsColumnTypes.nKgPerTon,
    RequestsColumnTypes.maxNitrogen,
    RequestsColumnTypes.pKgPerTon,
    RequestsColumnTypes.maxPhosphate,
    RequestsColumnTypes.kKgPerTon,
    RequestsColumnTypes.isHomogeneous,
    RequestsColumnTypes.desiredDeliveryPeriod,
    RequestsColumnTypes.paymentType,
    RequestsColumnTypes.pricePerTon,
    RequestsColumnTypes.totalPrice,
    RequestsColumnTypes.status,
  ];

  selectedCustomer$: Observable<SelectedCustomer> = this.store.pipe(
    select(UserSelectors.selectCustomer),
  );

  @ViewChild(MatTableDataSource) tableDataSource: MatTableDataSource<RequestsOverviewModel[]>;
}
